import React from 'react';
import { Link } from 'react-router-dom';
import { DashboardModuleView } from '../../types/dashboard';

interface DashboardCardProps {
  module: DashboardModuleView;
}

function DashboardCard({ module }: DashboardCardProps) {
  const statusClass = !module.available
    ? 'bg-slate-200 text-slate-500'
    : module.statusLabel.includes('UPDATE')
      ? 'bg-slate-200 text-slate-600'
      : 'bg-amber-100 text-amber-600';

  const cardContent = (
    <article
      className={`min-h-[248px] rounded-[18px] border px-6 py-7 transition ${
        module.available
          ? 'border-slate-200 bg-white text-slate-900 shadow-[0_20px_44px_-34px_rgba(15,23,42,0.55)] hover:-translate-y-0.5'
          : 'border-slate-200 bg-slate-100/90 text-slate-400 hover:-translate-y-0.5 hover:shadow-[0_20px_44px_-34px_rgba(15,23,42,0.3)]'
      }`}
    >
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="text-[28px] font-semibold tracking-tight">{module.title}</h2>
          <p className="mt-2 text-[15px] text-[#64748b]">{module.summaryLine}</p>
        </div>
        <span className={`rounded-full px-3 py-1 text-xs font-semibold uppercase ${statusClass}`}>
          {module.statusLabel}
        </span>
      </div>

      <p className={`mt-7 text-[15px] ${module.available ? 'text-slate-500' : 'text-slate-400'}`}>
        {module.subtitle}
      </p>
      <p className={`mt-4 text-[17px] leading-8 ${module.available ? 'text-[#60718f]' : 'text-slate-400'}`}>
        {module.description}
      </p>
      <p className={`mt-12 text-[14px] font-medium ${module.available ? 'text-amber-500' : 'text-slate-400'}`}>
        {module.helperText}
      </p>
    </article>
  );

  return (
    <Link to={module.route} className="block text-inherit no-underline">
      {cardContent}
    </Link>
  );
}

export default DashboardCard;
